/** Kopírování do schránky s jednotnou zpětnou vazbou (sonner). */

import { toast } from 'sonner';

export async function copyText(text: string, label: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${label} zkopírováno`);
  } catch {
    // Fallback pro prohlížeče bez Clipboard API (nebo bez HTTPS).
    try {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toast.success(`${label} zkopírováno`);
    } catch {
      toast.error('Kopírování se nezdařilo', { description: 'Zkopírujte prosím ručně.' });
    }
  }
}
